import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { TemplateUtenteProfilo } from '../../../models/profili-utente/template-utente-profilo';
import { UtenteProfilo } from '../../../models/profili-utente/utente-profilo';
import { UtenteUpdateComponent } from './utente-update.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [utente-mod-update]',
  templateUrl: 'utente-mod-update.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class UtenteModUpdateComponent {
  @Output() onReturnUtente: EventEmitter<UtenteProfilo> = new EventEmitter<UtenteProfilo>();
  @ViewChild('formUpdateUtente') modaleUtente: UtenteUpdateComponent;

  inizializza(urlUpdateUtente: string, urlGetTemplates: string, utente: UtenteProfilo, templateUtenteProfilo : TemplateUtenteProfilo) {
    this.modaleUtente.inizializza(urlUpdateUtente, urlGetTemplates, utente, templateUtenteProfilo);
    openModal('modalmodupdateutente');
  }

  createForm() {
    this.modaleUtente.createForm();
  }

  manageModal(utente: UtenteProfilo) {
      closeModal('modalmodupdateutente');
      this.onReturnUtente.emit(utente);
  }
}
